import { useEffect, useState } from "react"
import { Status } from "../day/dayView"
import { UserCustomerMatrixDTO } from "../../DTO/UserCustomerMatrixDTO"
import Spinner from "../../../components/Spinner/Spinner"
import { Box } from "@mui/material"

export default function UserCustomerMatrix() {
  const [status, setStatus] = useState(Status.loading)
  const [ucm] = useState(new UserCustomerMatrixDTO())
  useEffect(() => {
    ucm.getFromServer().then((data) => {
      console.log('data', data)
      setStatus(Status.standard)
    })
  }, [ucm])
  if (status === Status.loading) { return <Spinner /> } 
  return <Box
    sx={{
      padding: 2,
      backgroundColor: 'white',
    }}
  >
    <Box>-- Prototyp --</Box>
    <table
    style={{
      backgroundColor: 'white',
      width: '100%',
      borderCollapse: 'collapse',
    }}
  >
    <tbody>
    
      <tr>
        <th></th>
        {
          ucm.users.map((u) => {
            return <th key={`ucm-header-${u.userId}`}>{u.userName}</th>
          })
        }
      </tr>
      {
        ucm.customers.map((c) => {
          return <tr key={`ucm-row-${c.id}`}>
            <td
              style={{
                border: '1px solid grey',
                padding: 4,
              }}
            >{c.name}</td>
            {
              ucm.users.map((u) => {
                const match = ucm.userInCustomer(u.userId, c.id)
                return <td
                  key={`ucm-cell-${u.userId}-${c.id}`}
                  style={{
                    backgroundColor: match ? 'green' : 'white',
                    border: '1px solid grey',
                    color: 'white',
                    textAlign: 'center',
                  }}
                >{match ? 'X' : ''}</td>
              })
            }
          </tr>
        })
      }

    </tbody>
  </table>
</Box>
}
